<template>
  <div class="dashboard-container">
    <!-- <div class="balloons">
      <div class="balloon balloon-1">🎈</div>
      <div class="balloon balloon-2">🎈</div>
      <div class="balloon balloon-3">🎈</div>
      <div class="balloon balloon-4">🎈</div>
      <div class="balloon balloon-5">🎈</div>
    </div> -->

    <div class="dashboard-header">
      <!-- <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div>
      <div class="confetti"></div> -->

      <!-- <div class="breadcrumb-nav">
        <ol class="breadcrumb-list">
          <li class="breadcrumb-item">
            <a class="breadcrumb-link">MENÚ PRINCIPAL</a>
          </li>
          <li class="breadcrumb-separator">/</li>
          <li class="breadcrumb-item active">
            <span class="breadcrumb-current">INICIO</span>
          </li>
        </ol>
      </div> -->

      <div class="welcome-header">
        <h1 class="welcome-title">
          <span class="welcome-text">¡Bienvenido!:</span>
          <span class="username">{{ user.name }}</span>
        </h1>
        <!-- <div class="welcome-icon">🎉</div> -->
      </div>
    </div>

    <DashboardFilter @aplicar-filtros="onAplicarFiltros" />

    <div class="compact-cards">
      <div class="grid">
        <div
          class="col-12 sm:col-6 lg:col-3"
          v-if="'Producto Crear' in authService.user.permissions"
        >
          <div class="compact-card product-card">
            <div class="card-icon">
              <i class="pi pi-box"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ productos }}</div>
              <div class="card-label">Productos</div>
            </div>
            <router-link
              to="/productos"
              class="card-action"
              v-tooltip.top="'Ver Listado Productos'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>

        <div
          class="col-12 sm:col-6 lg:col-3"
          v-if="'Cliente Crear' in authService.user.permissions"
        >
          <div class="compact-card client-card">
            <div class="card-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ clientes }}</div>
              <div class="card-label">Clientes</div>
            </div>
            <router-link
              to="/clientes"
              class="card-action"
              v-tooltip.top="'Ver Listado Clientes'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>

        <div
          class="col-12 sm:col-6 lg:col-3"
          v-if="'Proveedor Crear' in authService.user.permissions"
        >
          <div class="compact-card supplier-card">
            <div class="card-icon">
              <i class="pi pi-users"></i>
            </div>
            <div class="card-content">
              <div class="card-value">{{ proveedores }}</div>
              <div class="card-label">Proveedores</div>
            </div>
            <router-link
              to="/proveedores"
              class="card-action"
              v-tooltip.top="'Ver Listado Proveedores'"
            >
              <i class="pi pi-eye"></i>
            </router-link>
          </div>
        </div>

        <div
          class="col-12 sm:col-6 lg:col-3"
          v-if="'Dashboard Comisiones' in authService.user.permissions"
        >
          <div class="compact-card commission-card">
            <div class="card-icon">
              <i class="pi pi-money-bill"></i>
            </div>
            <div class="card-content">
              <div class="card-value">
                {{ convertirNumeroGermanicFormat(total_comision) }} Bs
              </div>
              <div class="card-label">Por Cobrar</div>
            </div>
            <div class="card-actions">
              <Button
                v-tooltip.top="'Actualizar Comisiones'"
                class="p-button-rounded p-button-text p-button-success action-btn"
                icon="pi pi-refresh"
                @click="panel_necesario_auth()"
                :loading="obtenerDatos"
              />
              <Button
                :disabled="this.total_comision == 0"
                v-tooltip.top="'Ver Detalle de Comisiones'"
                class="p-button-rounded p-button-text p-button-help action-btn"
                icon="pi pi-file-pdf"
                @click="descargarComisionesPDF()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BLOQUE 1: SECCIÓN GRÁFICOS -->
    <div class="charts-grid mt-2">
      <!-- Gráfico 1: Productos y Servicios Más Vendidos -->
      <div class="sales-section flex flex-column h-full" v-if="false">
          <div class="section-header">
            <h2 class="section-title">
              <i class="pi pi-chart-line"></i>
              Productos y Servicios Más Vendidos
            </h2>
          </div>

          <div class="filter-section">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 sm:col-5">
                <i class="pi pi-calendar mr-2"></i>
                <span class="titulo">Fecha Inicio</span>
                <Calendar
                  v-model="fecha_inicio"
                  class="filter-calendar"
                  showIcon
                  dateFormat="dd/mm/yy"
                />
              </div>
              <div class="field col-12 sm:col-5">
                <i class="pi pi-calendar mr-2"></i>
                <span class="titulo">Fecha Fin</span>
                <Calendar
                  v-model="fecha_fin"
                  class="filter-calendar"
                  showIcon
                  dateFormat="dd/mm/yy"
                />
              </div>
              <div class="field col-12 sm:col-2 flex align-items-end">
                <Button                  
                  icon="pi pi-search"
                  class="p-button-raised w-full"
                  @click="panel_necesario_auth()"
                  :loading="obtenerDatos"
                />
              </div>
            </div>
          </div>

          <div class="charts-container flex-1">
            <div class="chart-card grid">
              <div class="col-12">
                <h3><i class="pi pi-shopping-bag"></i> Productos</h3>
                <Chart
                  v-if="
                    productos_mas_vendidos && productos_mas_vendidos.length > 0
                  "
                  type="doughnut"
                  :data="chartDataProdServ"
                  :options="chartOptionsProdServ"
                />
                <div v-else class="no-data">
                  <i class="pi pi-info-circle"></i>
                  <p>No hay datos de productos</p>
                </div>
              </div>
              <div class="col-12" v-if="servicios_mas_vendidos.length">
                <h3><i class="pi pi-wrench"></i> Servicios</h3>
                <div class="chart-wrapper">
                  <Chart
                    v-if="
                      servicios_mas_vendidos &&
                      servicios_mas_vendidos.length > 0
                    "
                    type="doughnut"
                    :data="chartDataServicios"
                    :options="chartOptionsServicios"
                  />
                  <div v-else class="no-data">
                    <i class="pi pi-info-circle"></i>
                    <p>No hay datos de servicios</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div> <!-- Cierra sales-section -->

      <!-- Nuevo Gráfico: Ventas del Mes -->
      <DashboardVentaMes v-if="'Dashboard Productos+Vendidos' in authService.user.permissions"
        :key="reloadKey"
        :fechaInicio="filterDashboard._rawFechaInicio" 
        :fechaFin="filterDashboard._rawFechaFin" 
        :sucursalId="filterDashboard.sucursal_id" 
        :grupoIds="filterDashboard.grupo_ids"
      />

      <!-- Gráfico 2: Ventas por Canal -->
      <DashboardCanalVenta v-if="'Dashboard Productos+Vendidos' in authService.user.permissions"
        :key="reloadKey"
        :fechaInicio="filterDashboard._rawFechaInicio" 
        :fechaFin="filterDashboard._rawFechaFin" 
        :sucursalId="filterDashboard.sucursal_id" 
        :grupoIds="filterDashboard.grupo_ids"
      />

      <!-- Gráfico 3: Ranking de Sucursales -->
      <DashboardRanking v-if="'Dashboard Productos+Vendidos' in authService.user.permissions"
        :key="reloadKey"
        :fechaInicio="filterDashboard._rawFechaInicio" 
        :fechaFin="filterDashboard._rawFechaFin"         
        :grupoIds="filterDashboard.grupo_ids"
      />

      <!-- Gráfico 4: Ticket Promedio -->
      <DashboardTicketPromedio v-if="'Dashboard Productos+Vendidos' in authService.user.permissions"
        :key="reloadKey"
        :fechaInicio="filterDashboard._rawFechaInicio" 
        :fechaFin="filterDashboard._rawFechaFin"         
        :sucursalId="filterDashboard.sucursal_id" 
        :grupoIds="filterDashboard.grupo_ids"
      />
    </div> <!-- Cierra BLOQUE 1 -->

    <!-- BLOQUE 2: SECCIÓN ALERTAS/TABLAS -->
    <div class="charts-grid mt-2">
      <!-- Panel 1: Productos Stock Cero -->
      <Panel
        v-if="'Dashboard ProductosStockCero' in authService.user.permissions"
        header="PRODUCTOS CON STOCK EN CERO"
        class="h-full alert-panel"
            :toggleable="true"
            :collapsed="true"
          >
            <DataTable
              ref="dtproductosstockcero"
              :value="stocks"
              :paginator="true"
              :rows="5"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              :filters="buscar"
              class="p-datatable-sm alert-table"
            >
              <template #header>
                <div class="table-header">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="buscar['global'].value"
                      placeholder="Buscar..."
                    />
                  </span>
                </div>
              </template>
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>¡Excelente! No hay productos con stock en cero</p>
                </div>
              </template>
              <Column field="nombre_sucursal" header="Sucursal"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="cantidad" header="Stock" class="text-right">
                <template #body="{ data }">
                  <span class="stock-badge zero-stock">{{
                    data.cantidad
                  }}</span>
                </template>
              </Column>
            </DataTable>
      </Panel>

      <!-- Panel 2: Productos Próximos a Vencer -->
      <Panel
        v-if="'Dashboard ProductosFechaVence' in authService.user.permissions"
        :icon="['pi', 'pi-calendar']"
        class="h-full alert-panel"
            header="PRODUCTOS QUE VENCEN EN 30 DÍAS"
            :toggleable="true"
            :collapsed="true"
          >
            <DataTable
              ref="dtproductos_fecha_vence"
              :value="productos_fecha_vence"
              :rows="5"
              :paginator="true"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              class="p-datatable-sm alert-table"
            >
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>No hay productos próximos a vencer</p>
                </div>
              </template>
              <Column field="nombre_laborario" header="Marca"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="fecha_vence" header="Vencimiento">
                <template #body="{ data }">
                  <span class="date-badge">{{ data.fecha_vence }}</span>
                </template>
              </Column>
            </DataTable>
      </Panel>

      <!-- Panel 3: Productos Stock Mínimo -->
      <Panel
        v-if="'Dashboard ProductosStockMin' in authService.user.permissions"
        :icon="['pi', 'pi-database']"
        class="h-full alert-panel"
            header="PRODUCTOS CON STOCK MÍNIMO"
            :toggleable="true"
            :collapsed="true"
          >
            <DataTable
              ref="dtproductos_stock_minimo"
              :value="productos_stock_minimo"
              :rows="5"
              :paginator="true"
              :loading="enviando"
              responsiveLayout="scroll"
              :rowsPerPageOptions="[5, 10, 20]"
              :filters="buscar"
              class="p-datatable-sm alert-table"
            >
              <template #header>
                <div class="table-header">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="buscar['global'].value"
                      placeholder="Buscar..."
                    />
                  </span>
                </div>
              </template>
              <template #loading>
                <div class="loading-spinner">
                  <ProgressSpinner />
                </div>
              </template>
              <template #empty>
                <div class="empty-message success-message">
                  <i class="pi pi-check-circle"></i>
                  <p>No hay productos con stock mínimo</p>
                </div>
              </template>
              <Column field="nombre_laboratorio" header="Marca"></Column>
              <Column field="nombre_producto" header="Producto"></Column>
              <Column field="stock_minimo" header="Mínimo"></Column>
              <Column field="stock_actual" header="Actual">
                <template #body="{ data }">
                  <span
                    :class="[
                      'stock-badge',
                      data.stock_actual <= data.stock_minimo
                        ? 'low-stock'
                        : 'ok-stock',
                    ]"
                  >
                    {{ data.stock_actual }}
                  </span>
                </template>
              </Column>
            </DataTable>
      </Panel>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import Panel from "primevue/panel";
import { useAuth } from "@/stores";
import ProductService from "@/service/ProductService";
import StockService from "@/service/StockService";
import UserService from "@/service/UserService";
import DashboardCanalVenta from "@/components/DashboardCanalVenta.vue";
import DashboardRanking from "@/components/DashboardRanking.vue";
import DashboardFilter from "./DashboardFilter.vue";
import DashboardVentaMes from "./DashboardVentaMes.vue";
import DashboardTicketPromedio from "./DashboardTicketPromedio.vue";

export default {
  components: {
    Panel,
    DashboardFilter,
    DashboardCanalVenta,
    DashboardRanking,
    DashboardVentaMes,
    DashboardTicketPromedio
  },
  data() {
    return {
      user: {},
      productos: null,
      clientes: null,
      proveedores: null,
      stocks: [],
      enviando: false,
      productos_fecha_vence: [],
      productos_stock_minimo: [],
      filterDashboard: {},
      reloadKey: 0,
      stockClass: (data) => {
        if (data.cantidad == 0) {
          return "text-red-500";
        }
      },
      collapsed: false,
      productos_mas_vendidos: [],
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      loading: false,
      obtenerDatos: false,
      total_comision: 0,
      fecha_inicio: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ),
      fecha_fin: new Date(),
      servicios_mas_vendidos: [],
      chartDataProdServ: {},
      chartOptionsProdServ: {},
      chartDataServicios: {},
      chartOptionsServicios: {},
    };
  },
  authService: null,
  productService: null,
  stockService: null,

  created() {
    this.authService = useAuth();
    this.productService = new ProductService();
    this.userService = new UserService();
    this.stockService = new StockService();
  },
  mounted() {
    this.user = { ...this.authService.user };
    this.productosStockCero();
    this.Obtenerproductos_fecha_vence();
    this.Obtenerproductos_stock_minimo();
    this.panel_necesario_auth();
  },
  methods: {
    descargarComisionesPDF() {
      let datos = {
        id: this.user.id,
        nombre_usuario: this.user.name,
      };
      this.userService.descargarComisionesPDF(datos);
    },
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    Obtenerproductos_fecha_vence() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        this.productService
          .getProductos_fecha_vence()
          .then((data) => {
            this.productos_fecha_vence = data.productos_fecha_vence ?? [];
            this.enviando = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    Obtenerproductos_stock_minimo() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        this.productService
          .getProductos_stock_minimo()
          .then((data) => {
            this.productos_stock_minimo = data.productos_stock_minimo;
            this.enviando = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    productosStockCero() {
      if (this.collapsed == true) {
        this.enviando = false;
      } else {
        this.enviando = true;
        this.stockService.productos_stock_cero().then((data) => {
          this.stocks = data.stocks;
          this.enviando = false;
        });
      }
    },
    panel_necesario_auth() {
      this.obtenerDatos = true;
      let datos = {
        id: this.user.id,
        panel: "panel_inicio",
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
      };
      this.userService.panel_necesario_auth(datos).then((data) => {
        this.productos = data.datos.total_productos ?? 0;
        this.clientes = data.datos.clientes ?? 0;
        this.proveedores = data.datos.proveedors ?? 0;
        this.productos_mas_vendidos = data.datos.productos_mas_vendidos ?? 0;
        this.servicios_mas_vendidos = data.datos.servicios_mas_vendidos ?? 0;
        this.total_comision = data.datos.total_comision ?? 0;

        // Configuración de gráficos
        if (this.productos_mas_vendidos.length > 0) {
          this.chartDataProdServ = {
            labels: this.productos_mas_vendidos.map(
              (item) => item.descripcion + " (" + item.cantidad + ")"
            ),
            datasets: [
              {
                data: this.productos_mas_vendidos.map((item) => item.cantidad),
                backgroundColor: [
                  "#FF6384",
                  "#36A2EB",
                  "#FFCE56",
                  "#4BC0C0",
                  "#9966FF",
                  "#FF9F40",
                ],
                hoverBackgroundColor: [
                  "#FF6384",
                  "#36A2EB",
                  "#FFCE56",
                  "#4BC0C0",
                  "#9966FF",
                  "#FF9F40",
                ],
              },
            ],
          };
        }
        this.chartOptionsProdServ = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
        };

        if (this.servicios_mas_vendidos.length > 0) {
          this.chartDataServicios = {
            labels: this.servicios_mas_vendidos.map(
              (item) => item.nombre_servicio + " (" + item.cantidad + ")"
            ),
            datasets: [
              {
                data: this.servicios_mas_vendidos.map((item) => item.cantidad),
                backgroundColor: [
                  "#4BC0C0",
                  "#FF9F40",
                  "#9966FF",
                  "#FF6384",
                  "#36A2EB",
                  "#FFCE56",
                ],
                hoverBackgroundColor: [
                  "#4BC0C0",
                  "#FF9F40",
                  "#9966FF",
                  "#FF6384",
                  "#36A2EB",
                  "#FFCE56",
                ],
              },
            ],
          };

          this.chartOptionsServicios = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: "bottom",
              },
            },
          };
        }
        this.obtenerDatos = false;
      });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    sinDecimal(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(numero);
    },

    /***
     * Maneja el evento emitido por el componente DashboardFilter
     * @param {Object} filtros - Objeto con los filtros seleccionados
     */
    onAplicarFiltros(payload) {
      // Guardamos el payload que nos envia DashboardFilter en la variable local
      this.filterDashboard = payload;
      // Forzamos el renderizado de los gráficos incrementando la llave
      this.reloadKey++;
    }
  },
};
</script>

<style scoped lang="scss">
.dashboard-container {
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  border: 1px solid #eee;
}

/* Efectos de globos */
.balloons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.balloon {
  position: absolute;
  font-size: 2rem;
  animation: float 8s infinite ease-in-out;
  opacity: 0.7;
}

.balloon-1 {
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.balloon-2 {
  top: 15%;
  right: 10%;
  animation-delay: 1s;
}

.balloon-3 {
  top: 25%;
  left: 15%;
  animation-delay: 2s;
}

.balloon-4 {
  top: 20%;
  right: 20%;
  animation-delay: 3s;
}

.balloon-5 {
  top: 30%;
  left: 25%;
  animation-delay: 4s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
  }
}

/* Confetti */
.dashboard-header {
  position: relative;
  margin-bottom: 2rem;
}

.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #ff6b6b;
  opacity: 0.7;
  animation: confetti-fall 5s infinite linear;

  &:nth-child(2) {
    background: #4ecdc4;
    left: 10%;
    animation-delay: 1s;
  }

  &:nth-child(3) {
    background: #ffd166;
    left: 20%;
    animation-delay: 2s;
  }

  &:nth-child(4) {
    background: #06d6a0;
    left: 30%;
    animation-delay: 3s;
  }

  &:nth-child(5) {
    background: #118ab2;
    left: 40%;
    animation-delay: 4s;
  }
}

@keyframes confetti-fall {
  0% {
    transform: translateY(-100px) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) rotate(360deg);
    opacity: 0;
  }
}

/* Breadcrumb */
.breadcrumb-nav {
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 0.5rem 1rem;
}

.breadcrumb-list {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0.5rem;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #6c757d;
}

.breadcrumb-current {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;
}

/* Header de bienvenida */
.welcome-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  z-index: 2;
}

.welcome-title {
  display: flex;
  margin: 0;
}

.welcome-text {
  font-size: 1.5rem;
  color: #6c757d;
  font-weight: 500;
}

.username {
  font-size: 1.5rem;
  color: #2c3e50;
  font-weight: 700;
  background: linear-gradient(135deg, #3498db, #2c3e50);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-icon {
  font-size: 2.5rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

/* Tarjetas compactas */
.compact-cards {
  margin-bottom: 1rem;
  position: relative;
  z-index: 2;
}

.compact-card {
  background: white;
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  }
}

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.product-card .card-icon {
  background: linear-gradient(135deg, #3498db, #2c3e50);
  color: white;
}

.client-card .card-icon {
  background: linear-gradient(135deg, #ff6384, #c90035);
  color: white;
}

.supplier-card .card-icon {
  background: linear-gradient(135deg, #ff9f40, #ff7f00);
  color: white;
}

.commission-card .card-icon {
  background: linear-gradient(135deg, #4bc0c0, #008b8b);
  color: white;
}

.card-content {
  flex: 1;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.card-label {
  font-size: 0.85rem;
  color: #6c757d;
  font-weight: 500;
}

.card-action {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3498db;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #3498db;
    color: white;
    transform: scale(1.1);
  }
}

.card-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  width: 36px;
  height: 36px;
}

/* Sección de ventas */
.sales-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  position: relative;
  z-index: 2;
}

.section-header {
  margin-bottom: 0.5rem;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #2c3e50;
  font-size: 1.25rem;
  margin: 0 0 0.5rem 0;
  font-weight: 600;

  i {
    color: #3498db;
  }
}

/* Filtros */
.filter-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.5rem;
}

.filter-field {
  display: flex;
  flex-direction: column;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.9rem;

  i {
    color: #3498db;
  }
}

.filter-calendar {
  width: 100%;
}

/* Gráficos */
.charts-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.chart-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 0.5rem;
  text-align: center;

  h3 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: #2c3e50;
    margin: 0 0 1rem 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
}

.chart-wrapper {
  position: relative;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;

  i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #adb5bd;
  }

  p {
    margin: 0;
    font-style: italic;
  }
}

/* Paneles de alertas */
.alert-panels {
  position: relative;
  z-index: 2;
}

.alert-panel {
  margin-bottom: 1rem;
  border-radius: 12px;
  overflow: hidden;

  :deep(.p-panel-header) {
    background: linear-gradient(135deg, #3498db, #2c3e50);
    border-bottom: 1px solid #dee2e6;
    font-weight: 600;
    color: #ffffff;
    padding: 1rem 1rem;
  }

  :deep(.p-panel-content) {
    padding: 1rem;
  }
}

.alert-table {
  :deep(.p-datatable-header) {
    border: none;
    padding: 0 0 1rem 0;
    background: transparent;
  }
}

.table-header {
  display: flex;
  justify-content: flex-end;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #6c757d;

  i {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  p {
    margin: 0;
    font-style: italic;
  }
}

.success-message {
  color: #28a745;
}

/* Badges */
.stock-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
}

.zero-stock {
  background: #ffebee;
  color: #dc3545;
}

.low-stock {
  background: #fff3cd;
  color: #856404;
}

.ok-stock {
  background: #d4edda;
  color: #155724;
}

.date-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  background: #e3f2fd;
  color: #0d6efd;
  font-weight: 600;
  font-size: 0.85rem;
}

/* Responsive */
@media (max-width: 960px) {
  .filter-grid {
    grid-template-columns: 1fr;
  }

  .charts-container {
    grid-template-columns: 1fr;
  }

  .welcome-header {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }
}

@media (max-width: 640px) {
  .dashboard-container {
    padding: 1rem;
  }

  .compact-card {
    text-align: center;
    gap: 0.75rem;
  }

  .card-actions {
    justify-content: center;
  }

  .welcome-text {
    font-size: 1.25rem;
  }

  .username {
    font-size: 1.5rem;
  }
  .titulo {
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #2c3e50;
    font-size: 0.9rem;
  }
}
/* Grid Responsivo Nativo para Gráficos */
.charts-grid {
  display: grid;
  grid-template-columns: 1fr; /* Por defecto (Móviles): 1 columna */
  gap: 1rem;

  > * {
    min-width: 0; /* Previene overflow horizontal */
  }

  /* Laptops y Monitores: Siempre 2 columnas máximo para no apretar */
  @media (min-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
